/**
 * Currency conversion and formatting utilities.
 *
 * DB stores prices in whole units (e.g. 150 CZK).
 * Stripe expects smallest unit (e.g. 15000 haléře).
 */
/** Currencies where 1 unit = 1 smallest unit (no subunits) */
const ZERO_DECIMAL_CURRENCIES = new Set([
    'BIF',
    'CLP',
    'DJF',
    'GNF',
    'JPY',
    'KMF',
    'KRW',
    'MGA',
    'PYG',
    'RWF',
    'UGX',
    'VND',
    'VUV',
    'XAF',
    'XOF',
    'XPF',
]);
/**
 * Convert whole currency units to smallest unit for Stripe.
 * Example: toSmallestUnit(150, 'CZK') => 15000
 */
export function toSmallestUnit(amount, currency) {
    if (ZERO_DECIMAL_CURRENCIES.has(currency.toUpperCase())) {
        return Math.round(amount);
    }
    return Math.round(amount * 100);
}
/**
 * Convert smallest unit back to whole currency units.
 * Example: fromSmallestUnit(15000, 'CZK') => 150
 */
export function fromSmallestUnit(amount, currency) {
    if (ZERO_DECIMAL_CURRENCIES.has(currency.toUpperCase())) {
        return amount;
    }
    return amount / 100;
}
/**
 * Format a price given in whole currency units using Intl.NumberFormat.
 * Example: formatPrice(150, 'CZK', 'cs-CZ') => "150,00 Kč"
 */
export function formatPrice(amount, currency, locale = 'cs-CZ') {
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
    }).format(amount);
}
/**
 * Short price display: "Zdarma" for 0, formatted price otherwise.
 * Expects amount in whole currency units (as stored in DB).
 */
export function formatPriceShort(amount, currency) {
    if (amount === 0) {
        return 'Zdarma';
    }
    return formatPrice(amount, currency);
}
